import { useQuery } from '@tanstack/react-query';

import { PeerTypes } from '../../store/types/peers';
import { useNotificationApi } from '../api';
import { notificationsKeys } from '../notifications-query-key-factory';
import { NotificationResponse } from '../types/notifications.types';

const useGetPeerNotification = <T extends PeerTypes>({
  causeId,
  peerId,
  peerType,
}: {
  causeId: string;
  peerId: string;
  peerType: T;
}) => {
  const NotificationsApi = useNotificationApi();

  const getPeerNotification = async () => {
    const { data } = await NotificationsApi.get<NotificationResponse>(
      `/notifications/${peerType}/${peerId}?cause_id=${causeId}`
    );
    return data.notification;
  };

  const key =
    causeId && peerId && peerType ? notificationsKeys.id(causeId)[peerType].id(peerId).all : [];

  return useQuery({
    queryKey: key,
    queryFn: getPeerNotification,
    enabled: !!causeId && !!peerId && !!peerType,
  });
};

export { useGetPeerNotification };
